import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import withErrorHandler from "COMPONENTS/withErrorHandler/withErrorHandler";
import UserWaiting from "./UserWaiting";
import { sendWebsocketMessage, disconnectWebsocket } from "WEBSOCKET/WebsocketHandler";
import { CONFIG, SESSION_STATUS } from "UTILS/Constants";
import { userSessionName } from "./selectors";
import { selectSessionStatus, selectUserAdmissionStatus } from "COMPONENTS/Dashboard/selectors";
import setLanguageAction from "COMPONENTS/CommonComponents/ChangeLanguage/setLanguageAction";
import { USER_ADMISSION_STATUS } from "../../Utils/Constants";
import { selectSessionEndedFlag } from "COMPONENTS/CommonComponents/Header/selectors.js";
import {selectSessionType} from "COMPONENTS/MainLayout/selectors";

export class UserWaitingContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spinnerVisibility: false,
    };
  }
  componentDidMount(){
    history.pushState(null, null, location.href);
    window.onpopstate = function(event) {
      history.go(1);
    }; 
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.sessionStatus === SESSION_STATUS.ACTIVE ) {
      if(this.props.userAdmissionStatus === USER_ADMISSION_STATUS.ADMITTED) {
        this.props.history.push(CONFIG.path.dashboard);
      }
    }
    if(this.props.userAdmissionStatus === USER_ADMISSION_STATUS.REJECTED
      || this.props.sessionStatus === SESSION_STATUS.DELETED
      || this.props.sessionStatus === SESSION_STATUS.UPDATED) {
      this.props.disconnectWebsocket();
    }
    // pushed user to session ended screen
    if(this.props.isSessionEnded) {
      this.props.history.push(CONFIG.path.sessionEnded); 
    }
  }
  
  onSelectChange = selectedLanguage => {
    this.props.setLanguageAction(selectedLanguage);
  };

  render() {
    return (
      <React.Fragment>
        <UserWaiting
          onSelectChange={this.onSelectChange}
          language={this.props.language}
          userSessionName={this.props.userSessionName}
          sessionStatus={this.props.sessionStatus}
          userAdmissionStatus={this.props.userAdmissionStatus}
          sessionType={this.props.sessionType}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.LanguageReducer.language,
    userSessionName: userSessionName(state),
    sessionStatus: selectSessionStatus(state),
    userAdmissionStatus: selectUserAdmissionStatus(state),
    isSessionEnded:selectSessionEndedFlag(state),
    sessionType:selectSessionType(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    sendWebsocketMessage,
    disconnectWebsocket,
    setLanguageAction
  }, dispatch);
};

export default withErrorHandler(
  connect(mapStateToProps, mapDispatchToProps)(UserWaitingContainer)
);
